import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { MismatchesApiAdapter } from '../adapters';
import { MismatchFilters } from '../models';

export const useExportMismatches = () => {
    const [isExporting, setIsExporting] = useState(false);
    const { toast } = useToast();
    const { t } = useTranslation('codMismatches');

    const exportMismatches = async (
        filters: Partial<MismatchFilters>,
        columns?: string[]
    ) => {
        setIsExporting(true);
        try {
            const httpClient = createHttpClient(apiClientWH);
            const adapter = new MismatchesApiAdapter(httpClient);

            const response = await adapter.exportMismatches(filters, columns);

            if (response.url_file) {
                // Abrir el archivo Excel en una nueva pestaña
                window.open(response.url_file, '_blank');

                toast({
                    title: t('export.success.title', 'Exportación exitosa'),
                    description: t('export.success.description', 'El archivo Excel se está descargando'),
                    variant: 'default',
                });
            } else {
                throw new Error(t('export.error.no_data', 'No se encontraron descuadres para exportar'));
            }
        } catch (error: any) {
            const errorMessage = error?.response?.data?.error || error.message;
            toast({
                title: t('export.error.title', 'Error al exportar'),
                description: errorMessage || t('export.error.unexpected', 'Ocurrió un error inesperado'),
                variant: 'destructive',
            });
        } finally {
            setIsExporting(false);
        }
    };

    return {
        exportMismatches,
        isExporting,
    };
};

